import { CreditCard } from "./credit-card";

export interface SearchResponse {
  totalRecords: number;
  items: Item[];
}

export interface Item {
  gcn: string;
  itemDetails: Product[];
}

export class AddProductToFavRequest {
  buid?: number;
  userDetailNum: number;
  favId: number;
  shipToNum: number;
  soldToNum: number;
  isWatchList: boolean;
  items: ItemNum[];
}

export class ItemNum {
  itemId: number;
}

export class Product {
  abcCode: string;
  ahfsCode: string;
  ahfsDescription: string;
  allocatedQuantity: number;
  amp: number;
  brandName: string;
  buid: string;
  color: string;
  deaclass: string;
  description: string;
  dosageForm: string;
  flavor: string;
  form: string;
  gcn: string;
  gcnCount: number;
  genericName: string;
  hin: string;
  imgData: string;
  isBlocked: number;
  itemId: number;
  isCSOS: boolean;
  isLowestPriceFlag: boolean;
  labelSize: string;
  manufacturer: string;
  accountType: string;
  mfrItemNumber: string;
  ndc: string;
  onOrder: number;
  orangeBookTherapeuticEquivalence: string;
  packQuantity: number;
  price: number;
  productType: string;
  shape: string;
  size: string;
  sku: string;
  specialHandling: string;
  specialHandlingDesc: string;
  storage: string;
  strength: string;
  substitutionKey: string;
  temperature: string;
  temperatureDesc: string;
  unitOfSale: string;
  upc: string;
  base64Image: string;
  cartQuantity: number;
  imageFormat: string;
  hasStock: boolean;
  excluded: boolean;
  isAvailable: boolean;
  availabilityMessage: string;
  isColdAlert: boolean;
  isHazardalert: boolean;
  favListSelected: any;
  isWatchListItem: boolean;
  favItemId: any;
  watchItemId: any;
  isFavListItem: any;
  unavailabilityReason?: string;
  isQtyMismatch?: boolean;
  errorCode?: string;
  isSubscribed: boolean;
  labelType: String;
  wareHouse: String;
  media: String;
  mediaName: String;
  negotiatedReason: Number;
  negotiatedPrice: Number;
  negotiationComments: string;
  isNegotiatePending: boolean;
  negotiateDays: Number;
  competitorName?:string;
  addedFromProductRecommended:string;
}

export class SusbscribedProducts{
  itemDetails: SusbscribedItemDetails[];
  subscriptionId: number;
  startDate: string;
  frequency: string;
  subTotal : number;
  tax : number;
  discount : number;
  netTotalAmount: number;
  paymentType:string;
  creditCardDetails: CreditCard;
  isUpdatable:boolean;
}

export class SusbscribedItemDetails{
  itemId: number;
  orderQuantity: number;
  description: string;
  unitPrice: number;
  totalPrice: number;
  packQuantity: number;
  allocatedQuantity:number;
  isAvailable:any;
  availableQuantity:number;
  allocationCase:String;
  showQuantityWarning:boolean;
  priceOverRide:boolean;
}

export class ConfirmSubscriptionRequest {
  accountShipToNum: string;
  accountSoldToNum: string;
  frequency: number;
  startDate: string;
  userDetailNum: number;
  buid: number;
  isShippingCost: boolean;
  customerSubscriptionItemVO: ConfirmSubscriptionItemRequest[];
  paymentType:string;
  creditCardNum: number;
}

export class ConfirmSubscriptionItemRequest {
  itemId: string;
  quantity: number;
  unitPrice: number;
}
export class SubscribedResponse{
  subscriptionId: any;
  customerSubscriptionItemVO: CustomerSubscriptionItemVO[];
}
export class CustomerSubscriptionItemVO{
  itemId: number;
}
export class UnsubscribeRequest{
  subscriptionId: number;
  shipToNum: string;
  soldToNum: string;
  itemId: Array<any>;
}

export class SkipSubscriptionDetails {
  subscriptionId: number;
  date: any;
  frequency:any;
  skipCustomerSubscriptionItemVO: SkipCustomerSubscriptionItemVO[];
}
export class SkipCustomerSubscriptionItemVO{
  itemId: number;
  description: string;
}
export class EditSubscriptionRequest {
  customerSubscriptionId: number;
  deliverytDate: string;
  frequency: number;
  customerSubscriptionItemVO: ConfirmSubscriptionItemRequest[];
  isShippingCost: boolean;
  paymentType:string;
  creditCardNum: number;
}
export interface ProductRealTimeRequest {
  itemDetails: ProductRealTimeRequestItem[];
  shipTo: number;
  soldTo: number;
}

export interface ProductRealTimePriceRequest {
  items: ProductRealTimePriceRequestItem[];
  shipTo: number;
  soldTo: number;
}

export interface ProductRealTimeRequestItem {
  itemId: number;
  isCSOS: boolean;
  gcn: string;
  labelSize: string;
  labelType: String;
}

export interface ProductRealTimePriceRequestItem {
  item: number;
  quantity: number;
}

export interface ProductRealTimeResponse {
  itemDetails: ProductRealTimeResponseItem[];
}

export interface ProductRealTimeResponseItem {
  itemId: number;
  isCSOS: boolean;
  price: number;
  allocatedQuantity: number;
}

export interface ProductRealTimePriceResponseItem {
  itemId: number;
  isCSOS: boolean;
  price: number;
  allocatedQuantity: number;
}

export interface ProductRealTimePriceResponse {
  totalAmount: number;
  itemDetails: ProductRealTimePriceResponseItem[];
}

export interface ValidateProductRequest {
  items: Array<ProductValidate>;
  shipToNum: number;
  soldToNum: number;
}

interface ProductValidate {
  itemId: string;
  orderQuantity: string;
  packQuantity: string;
}

export interface ProductPurchaseHistory {
  storeName: string;
  invoiceNumber: string;
  invoiceDate: string;
  invoicePrice: number;
  quantity: number;
  invoiceLineItem:string;
}

export interface PrebookProduct {
  itemId: number;
  orderQuantity: number;
  description: string;
  brandName: string;
  packageSize: string;
  manufacturer: string;
  releaseDate: string;
  createdDate: string;
  updatedDate: string;
}

export interface ProductFilter {
  config: { applied: boolean };
  stock: { available: boolean, enabled: boolean };
  strength: { values: any; selected: any };
  size: { values: any; selected: any };
  form: { values: any; selected: any };
  manufacturer: { values: any; selected: any }; 
  accountType?: {values:any; selected: any};
}
export interface ItemImagesVO {
  itemNum: string;
  imageDetails :any[];
}

export interface ProductHistoryDetails {
  invoiceNumber: string,
  invoiceDate: string,
  invoiceDateString: string,
  invoicePrice: string,
  quantity: string,
  cin: string,
  ndc: string,
  brandName: string,
  description: string,
  manufacturer: string,
  form: string,
  labelSize: string,
  currentPrice: number,
  isCSOS: number,
  onOrder: number,
  allocatedQuantity: number,
  sku: string,
  isWatchListItem: boolean,
  watchItemId: number,
  isFavListItem: boolean,
  itemId: string,
  packQuantity: number,
  isActive: boolean,
  shipToNum: string,
  soldToNum: string
}